<div class="public-layout h-screen flex items-center justify-center">
  <router-outlet></router-outlet>
</div>
